import { c as _c } from "react/compiler-runtime";
import { CalendarWithCheckIcon, GoogleMeetIcon, LinkIcon, PersonalLocationIcon, PhoneIcon, ZoomLocationIcon, WalletIcon } from '@systemeio/ui/icons';
import { DangerButton, Modal, PrimaryButton } from '@systemeio/ui';
import { RescheduleBookingModal } from 'modules/calendar/bookings/components/reshedule-booking-modal';
import { BookingStatusEnum } from 'modules/calendar/bookings/constants';
import { useBookingDetails } from 'modules/calendar/bookings/hooks/use-booking-details';
import { BookingDetailsInterface } from 'modules/calendar/bookings/types/booking-details-interface';
import { BookingViewInterface } from 'modules/calendar/bookings/types/bookings-interface';
import { EventLocationTypeEnum } from 'modules/calendar/events/constants';
import { EventTypeEnum } from 'modules/calendar/events/enums/event-type-enum';
import ClockIcon from 'modules/funnels/funnel/icons/clock-icon';
import React, { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { FieldLabel } from 'shared/components/form/field-label';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { timeFormat } from 'shared/utils/date-time-format';
import { BookingInviteeDetails } from 'modules/calendar/bookings/components/booking-invitee-details';
import { BookingPaymentStatusLink } from './booking-status';
interface BookingDetailsModalProps {
  opened: boolean;
  onClose: () => void;
  booking?: BookingViewInterface;
  onRescheduleBooking: (date: string, booking?: BookingViewInterface) => Promise<void>;
  isFetchingReschedule: boolean;
  onCancelBooking: (booking: BookingViewInterface) => Promise<void>;
  afterLeave?: () => void;
}
export const BookingDetailsModal = t0 => {
  const $ = _c(30);
  const {
    booking,
    onClose,
    opened,
    onRescheduleBooking,
    onCancelBooking,
    isFetchingReschedule,
    afterLeave
  } = t0;
  const {
    t,
    tICU
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const t1 = booking?.id;
  let t2;
  if ($[0] !== opened || $[1] !== t1) {
    t2 = {
      bookingId: t1,
      opened
    };
    $[0] = opened;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    bookingDetails,
    bookingDetailsMutate
  } = useBookingDetails(t2);
  const [openedRescheduleBookingModal, setOpenedRescheduleBookingModal] = useState(false);
  const [openedCancelBookingModal, setOpenedCancelBookingModal] = useState(false);
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.calendar.bookings.booking_details.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== booking || $[6] !== bookingDetails || $[7] !== bookingDetailsMutate || $[8] !== opened || $[9] !== t || $[10] !== tICU || $[11] !== user?.timeFormat) {
    t4 = <>{bookingDetails && booking ? <div><div className="flex flex-col gap-4"><FieldLabel wrapperProps={{
            className: "flex-col gap-3"
          }} label={t("dashboard.calendar.bookings.booking_details.event_name")} labelRightElement={bookingDetails.eventName} labelClassName="text-base text-text-primary" /><FieldLabel wrapperProps={{
            className: "flex-col gap-3"
          }} label={t("dashboard.calendar.bookings.booking_details.event_time")} labelRightElement={<div className="flex gap-1"><CalendarWithCheckIcon className="fill-brand-primary h-4 w-4" /><span>{timeFormat(booking.date, {
                timeFormat: user?.timeFormat
              })}</span></div>} labelClassName="text-base text-text-primary" /><FieldLabel wrapperProps={{
            className: "flex-col gap-3"
          }} label={t("dashboard.calendar.bookings.booking_details.event_duration")} labelRightElement={<div className="flex gap-1"><ClockIcon className="h-4 w-4" active={true} /><span>{tICU("global.name_of_times.minute_icu", {
                minutes: bookingDetails.eventDuration
              })}</span></div>} labelClassName="text-base text-text-primary" /><FieldLabel wrapperProps={{
            className: "flex-col gap-3"
          }} label={t("dashboard.calendar.bookings.booking_details.event_location")} labelRightElement={<FieldLocation bookingDetails={bookingDetails} />} labelClassName="text-base text-text-primary" />{booking.eventType === EventTypeEnum.Group ? <FieldLabel wrapperProps={{
            className: "flex-col gap-3"
          }} label={tICU("dashboard.calendar.bookings.booking_details.invitees_slot", {
            slotsLeft: booking.maxParticipants ? Math.max(0, booking.maxParticipants - booking.bookedSlots) : 0
          })} labelClassName="text-base text-text-primary" /> : <><FieldLabel wrapperProps={{
              className: "flex-col gap-3"
            }} label={t("dashboard.calendar.bookings.payment_title")} labelRightElement={bookingDetails.bookings[0] && <div className="flex gap-1"><WalletIcon className="fill-brand-primary h-4 w-4" /><BookingPaymentStatusLink booking={bookingDetails.bookings[0]} /></div>} labelClassName="text-base text-text-primary" /><FieldLabel wrapperProps={{
              className: "flex-col gap-3"
            }} label={t("dashboard.calendar.bookings.booking_details.invitee_name")} labelRightElement={bookingDetails.bookings[0] && <>{bookingDetails.bookings[0].contactId ? <LinkWithoutPrefetch className="primary-link" href={`/contacts/${bookingDetails.bookings[0].contactId}`} rel="noreferrer" target="_blank">{bookingDetails.bookings[0].inviteeName}</LinkWithoutPrefetch> : <span>{bookingDetails.bookings[0].inviteeName}</span>}</>} labelClassName="text-base text-text-primary" /></>}<div className="customScroll max-h-[280px] min-h-[180px] overflow-y-auto overflow-x-hidden">{bookingDetails.bookings.sort(_temp).map(bookings => <BookingInviteeDetails key={`question-${bookings.inviteeName}-${bookings.bookingId}`} booking={bookings} bookingDetails={bookingDetails} bookingDetailsMutate={bookingDetailsMutate} eventType={booking.eventType} opened={opened} />)}</div></div><div className="mt-7 flex justify-end gap-4">{booking.eventId !== null && ![BookingStatusEnum.Cancelled, BookingStatusEnum.Past].includes(booking.status) && <DangerButton onClick={() => setOpenedCancelBookingModal(true)} width="large">{t("dashboard.bookings.actions.cancel_booking")}</DangerButton>}{bookingDetails.status !== BookingStatusEnum.Cancelled && <PrimaryButton onClick={() => setOpenedRescheduleBookingModal(true)} width="large">{t("dashboard.bookings.actions.reschedule_booking")}</PrimaryButton>}</div></div> : <div className="flex justify-center"><Loader /></div>}</>;
    $[5] = booking;
    $[6] = bookingDetails;
    $[7] = bookingDetailsMutate;
    $[8] = opened;
    $[9] = t;
    $[10] = tICU;
    $[11] = user?.timeFormat;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== afterLeave || $[14] !== onClose || $[15] !== opened || $[16] !== t3 || $[17] !== t4) {
    t5 = <Modal opened={opened} onClose={onClose} afterLeave={afterLeave} title={t3}>{t4}</Modal>;
    $[13] = afterLeave;
    $[14] = onClose;
    $[15] = opened;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== booking || $[20] !== isFetchingReschedule || $[21] !== onCancelBooking || $[22] !== onRescheduleBooking || $[23] !== openedCancelBookingModal || $[24] !== openedRescheduleBookingModal || $[25] !== t) {
    t6 = booking && <><ConfirmationModal toastCaption={t("dashboard.bookings.actions.cancel_booking_success")} confirmationText={t("dashboard.calendar.bookings.actions.cancel_booking_confirm")} opened={openedCancelBookingModal} onClose={() => setOpenedCancelBookingModal(false)} onConfirm={() => onCancelBooking(booking)} /><RescheduleBookingModal opened={openedRescheduleBookingModal} onClose={() => setOpenedRescheduleBookingModal(false)} booking={booking} onRescheduleBooking={onRescheduleBooking} isFetchingReschedule={isFetchingReschedule} eventType={booking.eventType} bookingId={booking.id} /></>;
    $[19] = booking;
    $[20] = isFetchingReschedule;
    $[21] = onCancelBooking;
    $[22] = onRescheduleBooking;
    $[23] = openedCancelBookingModal;
    $[24] = openedRescheduleBookingModal;
    $[25] = t;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== t5 || $[28] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
};
type FieldLocationProps = {
  bookingDetails: BookingDetailsInterface;
};
const FieldLocation = t0 => {
  const $ = _c(28);
  const {
    bookingDetails
  } = t0;
  const {
    t
  } = useLocoTranslation();
  switch (bookingDetails.locationType) {
    case EventLocationTypeEnum.Phone:
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <PhoneIcon className="fill-brand-primary h-4 w-4" />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        const t2 = `tel:${bookingDetails.phone}`;
        let t3;
        if ($[1] !== bookingDetails.phone || $[2] !== t2) {
          t3 = <div className="flex items-center gap-1">{t1}<a className="primary-link" href={t2} type="phone">{bookingDetails.phone}</a></div>;
          $[1] = bookingDetails.phone;
          $[2] = t2;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        return t3;
      }
    case EventLocationTypeEnum.ExternalLink:
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <LinkIcon className="fill-brand-primary h-4 w-4" />;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        let t2;
        if ($[5] !== bookingDetails.location) {
          t2 = <div className="flex items-center gap-1">{t1}{" "}<a className="primary-link" href={bookingDetails.location} rel="noreferrer" target="_blank">{bookingDetails.location}</a></div>;
          $[5] = bookingDetails.location;
          $[6] = t2;
        } else {
          t2 = $[6];
        }
        return t2;
      }
    case EventLocationTypeEnum.Zoom:
      {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ZoomLocationIcon className="fill-brand-primary h-4 w-4" />;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        let t2;
        if ($[8] !== bookingDetails.location) {
          t2 = <div className="flex items-center gap-1">{t1}<a className="primary-link" href={bookingDetails.location} rel="noreferrer" target="_blank">{bookingDetails.location}</a></div>;
          $[8] = bookingDetails.location;
          $[9] = t2;
        } else {
          t2 = $[9];
        }
        return t2;
      }
    case EventLocationTypeEnum.GoogleMeet:
      {
        let t1;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <GoogleMeetIcon className="h-4 w-4" />;
          $[10] = t1;
        } else {
          t1 = $[10];
        }
        let t2;
        if ($[11] !== bookingDetails.location) {
          t2 = <div className="flex items-center gap-1">{t1}<a className="primary-link" href={bookingDetails.location} rel="noreferrer" target="_blank">{bookingDetails.location}</a></div>;
          $[11] = bookingDetails.location;
          $[12] = t2;
        } else {
          t2 = $[12];
        }
        return t2;
      }
    case EventLocationTypeEnum.Personal:
      {
        let t1;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <PersonalLocationIcon className="fill-brand-primary h-4 w-4" />;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        let t2;
        if ($[14] !== t) {
          t2 = t("dashboard.calendar.event_location_address");
          $[14] = t;
          $[15] = t2;
        } else {
          t2 = $[15];
        }
        let t3;
        if ($[16] !== bookingDetails.location || $[17] !== t2) {
          t3 = <span>{t2}: {bookingDetails.location}</span>;
          $[16] = bookingDetails.location;
          $[17] = t2;
          $[18] = t3;
        } else {
          t3 = $[18];
        }
        let t4;
        if ($[19] !== bookingDetails.phone || $[20] !== t) {
          t4 = bookingDetails.phone && <div className="flex gap-1"><span>{t("dashboard.calendar.event_location.phone")}: </span><a className="primary-link" href={`tel:${bookingDetails.phone}`} type="phone">{bookingDetails.phone}</a></div>;
          $[19] = bookingDetails.phone;
          $[20] = t;
          $[21] = t4;
        } else {
          t4 = $[21];
        }
        let t5;
        if ($[22] !== t3 || $[23] !== t4) {
          t5 = <div className="flex gap-1">{t1}<div className="flex flex-col gap-1">{t3}{t4}</div></div>;
          $[22] = t3;
          $[23] = t4;
          $[24] = t5;
        } else {
          t5 = $[24];
        }
        return t5;
      }
    default:
      {
        let t1;
        if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <LinkIcon className="fill-brand-primary h-4 w-4" />;
          $[25] = t1;
        } else {
          t1 = $[25];
        }
        let t2;
        if ($[26] !== bookingDetails.location) {
          t2 = <div className="flex items-center gap-1">{t1}<a className="primary-link" href={bookingDetails.location} rel="noreferrer" target="_blank">{bookingDetails.location}</a></div>;
          $[26] = bookingDetails.location;
          $[27] = t2;
        } else {
          t2 = $[27];
        }
        return t2;
      }
  }
};
function _temp(a, b) {
  return Number(a.status === BookingStatusEnum.Cancelled) - Number(b.status === BookingStatusEnum.Cancelled);
}